import 'whatwg-fetch' // polyfill needed for now

const initDefaults = {
  credentials: 'same-origin',
  headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
}

export default function fetchJSON (url, body = false, init = {}, { parseErrors = true } = {}) {
  // apply defaults to init
  init = { ...initDefaults, ...init }
  const rejectOnErrorStatus = response => {
    if (response.ok) {
      return response
    } else {
      return parseErrors
        ? response.json().then(json => Promise.reject(json))
        : Promise.reject(response)
    }
  }

  if (body) {
    init.body = JSON.stringify(body)
    init.headers = init.headers ? Object.assign({}, init.headers) : {}
    init.headers['Content-Type'] = 'application/json'
    init.method = init.method || 'POST'
  }

  return window.fetch(url, init)
    .then(rejectOnErrorStatus)
    .then(response => response.json())
}
